var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import { ACTION_PRICE_EXPLORER_GRID as actionTypes, CONSTANTS } from '../utils/constants';
import { bulkEval, getSellersForSku, modifyBulkEvalResults, getCompetitorsPrices, getContractPrices } from '../services/productPrice';
import { capitalize, createEmptyRows, getPivots, getRowData, isEmptyArray, makeCancelable, sort } from '../utils/utils';
import { getShippingPrices, getShippingPricesForContracts } from '../services/shippingPrice';
import { fetchPackDefinitions, fetchQuantityFromData, getProductionTimeForSku, createProductConfiguration } from '../services/shippingutil';
import cloneDeep from 'lodash/cloneDeep';
import { get, find } from 'lodash';
import request from '../services/request';
import util from 'util';
import { getUserPermission } from '../services/userPermission';
export var saveRuleSetInfoPerSku = function saveRuleSetInfoPerSku(ruleSetInfoPerSku) {
  return {
    type: actionTypes.SAVE_RULE_SET_INFO,
    payload: ruleSetInfoPerSku
  };
};
export var setRowDataByResults = function setRowDataByResults(rowData) {
  return {
    type: actionTypes.SET_ROW_DATA_BY_RESULTS,
    payload: rowData
  };
};
export var setGridHeaders = function setGridHeaders(headers) {
  return {
    type: actionTypes.SET_GRID_HEADERS,
    payload: headers
  };
};
export var setRowDataByPriceMode = function setRowDataByPriceMode(priceMode) {
  return {
    type: actionTypes.SET_ROW_DATA_BY_PRICE_MODE,
    payload: priceMode
  };
};
export var addErrorMessageToHeaders = function addErrorMessageToHeaders(errorType, errorMessage, sku) {
  return {
    type: actionTypes.ADD_ERROR_MESSAGES_TO_HEADERS,
    payload: {
      errorMessage: errorMessage,
      errorType: errorType,
      sku: sku
    }
  };
};

var setIsLoadingEquivalencies = function setIsLoadingEquivalencies(isLoadingEquivalencies) {
  return {
    type: actionTypes.SET_IS_LOADING_EQUIVALENCIES,
    payload: isLoadingEquivalencies
  };
};

export var createHeaders = function createHeaders(skuData, isSingleSkuEnvironment, showCompetitivePricing, productPriceContractsInfo) {
  return {
    type: actionTypes.CREATE_HEADERS,
    payload: {
      skuData: skuData,
      isSingleSkuEnvironment: isSingleSkuEnvironment,
      showCompetitivePricing: showCompetitivePricing,
      productPriceContractsInfo: productPriceContractsInfo
    }
  };
};
export var createCompetitiveHeaders = function createCompetitiveHeaders(skuData, competitors, showCompetitivePricing) {
  return {
    type: actionTypes.CREATE_COMPETITIVE_HEADERS,
    payload: {
      skuData: skuData,
      competitors: competitors,
      showCompetitivePricing: showCompetitivePricing
    }
  };
};

var createDummyRows = function createDummyRows(_a) {
  var error = _a.error,
      sku = _a.sku,
      dispatch = _a.dispatch,
      getState = _a.getState;
  var _b = getState().pricingGrid,
      skuData = _b.skuData,
      isSingleSkuEnvironment = _b.isSingleSkuEnvironment,
      showCompetitivePricing = _b.showCompetitivePricing,
      productPriceContractsInfo = _b.productPriceContractsInfo;
  var headers = getState().priceExplorerGrid.headers;
  var fulfillerId = 'dummy';
  var contracts = [];
  contracts.push({
    buyer: {
      buyerId: CONSTANTS.CATALOG_PRICE
    },
    seller: {
      sellerId: fulfillerId
    }
  });

  if (!headers) {
    dispatch(createHeaders(skuData, isSingleSkuEnvironment, showCompetitivePricing, productPriceContractsInfo));
  }

  if (error) {
    var errorType = error.errorType,
        errorMessage = error.errorMessage;
    dispatch(addErrorMessageToHeaders(errorType, errorMessage, sku));
  }

  return createEmptyRows({
    mcpSku: sku,
    contracts: contracts,
    fulfillerId: fulfillerId,
    getState: getState
  });
}; // get priceModelInfo by redux thunk getPriceModelInfo, and set the result to store by setPriceModelInfo


var setPriceModelInfo = function setPriceModelInfo(contractResults) {
  return {
    type: actionTypes.SET_PRICE_MODEL_INFO,
    payload: contractResults
  };
}; // export const removeErrorMessageFromHeaders = (isSingleSkuEnvironment: boolean, type: any) => ({
//   type: actionTypes.REMOVE_ERROR_MESSAGE_FROM_HEADERS,
//   payload: { isSingleSkuEnvironment, type },
// });
// get sellers by redux thunk getSellers, and set the result to store by setSellers


var setSellers = function setSellers(sellers) {
  return {
    type: actionTypes.SET_SELLERS,
    payload: sellers
  };
};

var setMerchants = function setMerchants(merchants) {
  return {
    type: actionTypes.SET_MERCHANTS,
    payload: merchants
  };
};

var setPriceConfigurations = function setPriceConfigurations(configurations) {
  return {
    type: actionTypes.SET_PRICE_CONFIGURATIONS,
    payload: configurations
  };
};

export var setPricingVersion = function setPricingVersion(pricingVersion) {
  return {
    type: actionTypes.SET_PRICING_MODE,
    payload: pricingVersion
  };
};

var setAccountMap = function setAccountMap(accountMap) {
  return {
    type: actionTypes.SET_ACCOUNT_MAP,
    payload: accountMap
  };
};

export var getSellers = function getSellers() {
  return function (dispatch, getState) {
    var _a = getState().pricingGrid,
        skuData = _a.skuData,
        isProduction = _a.isProduction,
        logger = _a.logger,
        productPriceContractsInfo = _a.productPriceContractsInfo;
    var _b = getState().priceExplorerGrid,
        sellers = _b.sellers,
        accountMap = _b.accountMap;
    var promises = [];

    if (Object.keys(skuData).length < 1) {
      return Promise.resolve();
    }

    if (productPriceContractsInfo && productPriceContractsInfo.version === 'v2') {
      dispatch(setPriceConfigurations(productPriceContractsInfo.priceConfigurations));
      dispatch(setPricingVersion('v2'));
      return Promise.resolve();
    }

    var dateString = new Date().toISOString(); // check whether sku has pricing in v1 or v2

    var mcpSku = Object.keys(skuData)[0];
    var priceConfigurationUrl = 'https://priceconfiguration.ff.cimpress.io/api/v1/pricedEntities?priceDomain=product&resourceId=%s&resourceType=product$fromDate=%s&offset=0&limit=1000';
    return request(util.format(priceConfigurationUrl, mcpSku, dateString)).then(function (response) {
      if (response && response.count > 0) {
        // v2 pricing
        var accounts_1 = [];
        var priceConfigurations = response._embedded.item;
        priceConfigurations.forEach(function (configuration) {
          var buyer = configuration.buyer,
              seller = configuration.seller;

          if (buyer && !accounts_1.includes(buyer)) {
            accounts_1.push(buyer);
          }

          if (seller && !accounts_1.includes(seller)) {
            accounts_1.push(seller);
          }
        });
        var accountPromises_1 = [];
        accounts_1.forEach(function (account) {
          if (!accountMap[account]) {
            accountPromises_1.push(request(util.format('https://accounts.cimpress.io/api/v1/accounts/%s', account)));
          }
        });
        var hasPermissionForFulfiller = {}; // TODO ISN'T THIS ASYNC CALL

        hasPermissionForFulfiller[mcpSku] = getUserPermission(skuData[mcpSku].sellerId);
        dispatch(setPriceConfigurations(response._embedded.item));
        dispatch(setPricingVersion('v2'));
        dispatch(saveUserPermissionForFulfiller(hasPermissionForFulfiller));

        if (accountPromises_1.length > 0) {
          return Promise.all(accountPromises_1).then(function (results) {
            results.forEach(function (result) {
              var accountId = result.accountId,
                  name = result.name,
                  cimpressOwned = result.cimpressOwned;
              accountMap[accountId] = {
                accountId: accountId,
                name: name,
                cimpressOwned: cimpressOwned
              };
            });
            dispatch(setAccountMap(accountMap));
          });
        }

        return Promise.resolve();
      } // v1 pricing


      Object.keys(skuData).forEach(function (sku) {
        var sellerId = skuData[sku].sellerId;

        if (sku !== 'competitorProducts') {
          if (!sellers[sku]) {
            promises.push(getSellersForSku(sku, sellerId, isProduction, productPriceContractsInfo));
          }
        }
      });

      if (promises.length) {
        return Promise.all(promises).then(function (sellerData) {
          var allSellers = {};
          var allMerchants = {};
          var catalogPriceModels = {};
          var contracts = {};
          var manufacturingCostModels = {};
          var hasPermissionForFulfiller = {};
          sellerData.forEach(function (sellerMap) {
            Object.entries(sellerMap).forEach(function (_a) {
              var _b = __read(_a, 2),
                  sku = _b[0],
                  value = _b[1];

              allSellers[sku] = value.sellers;
              allMerchants[sku] = value.merchants;
              catalogPriceModels[sku] = value.catalogPriceModels;
              contracts[sku] = value.contracts;
              manufacturingCostModels[sku] = value.manufacturingCostModels;
              hasPermissionForFulfiller[sku] = !!value.hasPermissionForFulfiller;
            });
          });
          dispatch(setSellers(allSellers));
          dispatch(setMerchants(allMerchants));
          dispatch(setPriceModelInfo({
            contracts: contracts,
            catalogPriceModels: catalogPriceModels,
            manufacturingCostModels: manufacturingCostModels
          }));
          dispatch(saveUserPermissionForFulfiller(hasPermissionForFulfiller));
          dispatch(setPricingVersion('v1'));
        }).catch(function (error) {
          return logger.logError("Error in fetching seller info " + error);
        });
      }

      return Promise.resolve();
    });
  };
};

var setCancelablePromise = function setCancelablePromise(cancelablePromise) {
  return {
    type: actionTypes.SET_CANCELABLE_PROMISE,
    payload: cancelablePromise
  };
};

var createDummyResults = function createDummyResults(_a) {
  var _b;

  var error = _a.error,
      sku = _a.sku,
      dispatch = _a.dispatch,
      getState = _a.getState;
  var skuData = getState().pricingGrid.skuData;
  var selectedRow = skuData[sku].selectedRow;
  var newSku;
  var rowData;

  if (!sku) {
    _b = __read(Object.keys(skuData), 1), newSku = _b[0];
    rowData = createDummyRows({
      error: error,
      sku: newSku,
      dispatch: dispatch,
      getState: getState
    });
  } else {
    rowData = createDummyRows({
      error: error,
      sku: sku,
      dispatch: dispatch,
      getState: getState
    });
  }

  var gridRowData = getRowData([rowData], selectedRow);
  dispatch(setRowDataByResults(gridRowData));
  return gridRowData;
};

var bulkEvaluate = function bulkEvaluate(isProduction, sku, evaluationParameters, fulfillerId, contracts, catalogPriceModels, manufacturingCostModels, skuData, productPriceContractsInfo, getState) {
  return bulkEval(isProduction, sku, evaluationParameters, fulfillerId, contracts, catalogPriceModels, manufacturingCostModels, productPriceContractsInfo).then(function (results) {
    var _a = getState().priceExplorerGrid,
        headers = _a.headers,
        sellers = _a.sellers;
    var priceMode = getState().pricingGrid.priceMode;
    var pivots = getPivots(skuData[sku]);
    return modifyBulkEvalResults(results, pivots, priceMode, headers, sku, skuData, contracts, catalogPriceModels, manufacturingCostModels, sellers, productPriceContractsInfo);
  });
};

var getQuantity = function getQuantity(resourceGroupKey) {
  if (resourceGroupKey.toLowerCase().includes('quantity')) {
    var _a = __read(resourceGroupKey.toLowerCase().split('||'), 2),
        row = _a[0],
        column = _a[1];

    if (row.includes('quantity')) {
      return row.split('|')[1];
    }

    if (column.includes('quantity')) {
      return column.split('|')[1];
    }
  }

  return null;
};

var getQuantityFromAttributes = function getQuantityFromAttributes(attributes) {
  var quantityAttribute = attributes.find(function (attribute) {
    return attribute.name.toLowerCase() === 'quantity';
  });
  return quantityAttribute.value;
};

var getErrorMessage = function getErrorMessage(caveats) {
  var errorMessage = '';
  caveats.forEach(function (caveat) {
    errorMessage += caveat.message;
  });
  return errorMessage;
};

var calculatePriceList = function calculatePriceList(isSingleSkuEnvironment, sku, dispatch, getState) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a, isProduction, skuData, productPriceContractsInfo, _b, catalogPriceModelsPerSku, contractsPerSku, manufacturingCostModelsPerSku, pricingVersion, priceConfigurations, accountMap, resourceId_1, resourceType_1, resourceGroups_1, attributesMap_1, date_1, iterations_1, body, result, iterationMap_1, rowDataMap_1, _c, key_1, selectedValues, fixedQuantity_1, fulfillerId, iterations, error, contracts, evaluationParameters;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          _a = getState().pricingGrid, isProduction = _a.isProduction, skuData = _a.skuData, productPriceContractsInfo = _a.productPriceContractsInfo;
          _b = getState().priceExplorerGrid, catalogPriceModelsPerSku = _b.catalogPriceModelsPerSku, contractsPerSku = _b.contractsPerSku, manufacturingCostModelsPerSku = _b.manufacturingCostModelsPerSku, pricingVersion = _b.pricingVersion, priceConfigurations = _b.priceConfigurations, accountMap = _b.accountMap;
          if (!(pricingVersion === 'v2')) return [3
          /*break*/
          , 3];
          resourceId_1 = sku;
          resourceType_1 = 'product';
          resourceGroups_1 = [];
          attributesMap_1 = {};
          if (!(skuData[sku] && skuData[sku].resolvedAttributes && skuData[sku].resolvedAttributes.length)) return [3
          /*break*/
          , 2];
          skuData[sku].resolvedAttributes.forEach(function (item) {
            item.values.forEach(function (value) {
              if (value.attributes && value.attributes.length && value.state === CONSTANTS.FULLYRESOLVED) {
                var attributeMap_1 = {};
                value.attributes.forEach(function (attribute) {
                  var name = attribute.attributeKey,
                      attributeValue = attribute.attributeValue;
                  attributeMap_1[name + "|product"] = {
                    scope: 'product',
                    name: name,
                    value: attributeValue
                  };
                });
                attributeMap_1["Product Id|product"] = {
                  scope: 'product',
                  name: 'Product Id',
                  value: sku
                };
                var inputSelections = Object.values(attributeMap_1);
                var resourceKey = item.key;

                if (value.key) {
                  resourceKey = item.key + "||" + value.key;
                }

                resourceGroups_1.push({
                  resourceGroupKey: resourceKey,
                  resources: [{
                    resourceKey: resourceKey,
                    resourceId: resourceId_1,
                    resourceType: resourceType_1,
                    inputSelections: inputSelections
                  }]
                });
                attributesMap_1[resourceKey] = inputSelections;
              }
            });
          });
          if (!(resourceGroups_1.length > 0)) return [3
          /*break*/
          , 2];
          date_1 = new Date().toISOString();

          if (productPriceContractsInfo && productPriceContractsInfo.version === 'v2') {
            iterations_1 = priceConfigurations.map(function (config) {
              config.iterationKey = config.title;
              return config;
            });
          } else {
            iterations_1 = priceConfigurations.map(function (config) {
              config.iterationKey = config.buyer + "|" + config.seller + "||" + config.priceType;
              config.evaluationDate = date_1;
              return config;
            });
          }

          body = JSON.stringify({
            iterations: iterations_1,
            resourceGroups: resourceGroups_1
          });
          return [4
          /*yield*/
          , request('https://priceconfiguration.ff.cimpress.io/api/v1/priceEvaluations:bulkEvaluate', 'POST', body)];

        case 1:
          result = _d.sent();
          iterationMap_1 = {};
          result.iterations.forEach(function (iteration) {
            var iterationKey = iteration.iterationKey,
                buyer = iteration.buyer,
                seller = iteration.seller,
                priceType = iteration.priceType;

            if (productPriceContractsInfo && productPriceContractsInfo.version === 'v2') {
              iterationMap_1[iterationKey] = iterationKey;
            } else if (priceType === 'transferPrice') {
              iterationMap_1[iterationKey] = sku + "|Contracts|" + accountMap[seller].name + "-" + accountMap[buyer].name + "||";
            } else if (priceType === 'manufacturingCost') {
              iterationMap_1[iterationKey] = sku + "|Manufacturing Cost|" + accountMap[seller].name + "||";
            } else if (priceType === 'catalogPrice') {
              iterationMap_1[iterationKey] = sku + "|Catalog Price|" + accountMap[seller].name + "||";
            }
          });
          rowDataMap_1 = {};
          _c = skuData[sku].selectedRow, key_1 = _c.key, selectedValues = _c.selectedValues;
          selectedValues.forEach(function (value) {
            var _a;

            rowDataMap_1[key_1 + "|" + value] = (_a = {}, _a[key_1] = value, _a);
          });
          fixedQuantity_1 = null;
          result.resultGroups.forEach(function (resultGroup) {
            var productPrice;
            var errorMessage;
            var iterationKey = resultGroup.iterationKey,
                totals = resultGroup.totals,
                resourceGroupKey = resultGroup.resourceGroupKey,
                caveats = resultGroup.caveats;

            if (totals.length === 1) {
              var _a = totals[0],
                  totalPrice = _a.amount,
                  currency = _a.currency;
              productPrice = {
                totalPrice: totalPrice,
                displayPrice: totalPrice,
                currency: currency
              };
            } else if (totals.length === 0) {
              errorMessage = getErrorMessage(caveats);
            } else {
              errorMessage = 'Price has been configured in multiple currencies';
            }

            var _b = __read(resourceGroupKey.split('||'), 2),
                row = _b[0],
                column = _b[1];

            var columnKey = iterationMap_1[iterationKey];

            if (column) {
              columnKey = iterationMap_1[iterationKey].substr(0, iterationMap_1[iterationKey].length - 1) + column.split('|')[1] + '|';
            }

            var quantity = fixedQuantity_1 || getQuantity(resourceGroupKey);

            if (!quantity) {
              fixedQuantity_1 = getQuantityFromAttributes(attributesMap_1[resourceGroupKey]);
              quantity = fixedQuantity_1;
            }

            rowDataMap_1[row][columnKey] = {
              productPrice: productPrice,
              quantity: quantity,
              errorMessage: errorMessage,
              attributes: attributesMap_1[resourceGroupKey]
            };
          });
          return [2
          /*return*/
          , Object.values(rowDataMap_1)];

        case 2:
          return [2
          /*return*/
          , undefined];

        case 3:
          fulfillerId = skuData[sku].sellerId;
          iterations = [];

          if (skuData[sku] && skuData[sku].resolvedAttributes && skuData[sku].resolvedAttributes.length) {
            skuData[sku].resolvedAttributes.forEach(function (item) {
              item.values.forEach(function (value) {
                if (value.attributes && value.attributes.length && value.state === CONSTANTS.FULLYRESOLVED) {
                  iterations.push({
                    valueAttributes: value.attributes
                  });
                }
              });
            });
          }

          if (iterations.length === 0) {
            if (!contractsPerSku[sku]) {
              error = {
                errorType: 'error',
                errorMessage: CONSTANTS.NO_PRICE_MESSAGE
              };
              return [2
              /*return*/
              , createDummyRows({
                error: error,
                sku: sku,
                dispatch: dispatch,
                getState: getState
              })];
            }

            contracts = isEmptyArray(contractsPerSku[sku]) ? [] : JSON.parse(JSON.stringify(contractsPerSku[sku]));
            contracts.push({
              buyer: {
                buyerId: CONSTANTS.CATALOG_PRICE
              },
              seller: {
                sellerId: fulfillerId
              }
            });
            return [2
            /*return*/
            , createEmptyRows({
              mcpSku: sku,
              contracts: contracts,
              fulfillerId: fulfillerId,
              errorInfo: {},
              getState: getState
            })];
          }

          evaluationParameters = {
            iterations: iterations
          };
          return [2
          /*return*/
          , bulkEvaluate(isProduction, sku, evaluationParameters, fulfillerId, contractsPerSku[sku], catalogPriceModelsPerSku[sku], manufacturingCostModelsPerSku[sku], skuData, productPriceContractsInfo, getState)];
      }
    });
  });
};

var getAllCompetitivePrices = function getAllCompetitivePrices(skuData, competitors) {
  var _a;

  var competitiveProducts = skuData.competitorProducts;
  var sku = Object.keys(skuData)[0];
  var skuDetails = skuData[sku];
  var combinations = (_a = skuDetails.resolvedAttributes) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
    var key = _a.key,
        values = _a.values;
    var totalAttributes = values.map(function (_a) {
      var attributes = _a.attributes;
      return attributes;
    });
    var attributeMap = {};
    var normalizedAttributes = [];
    totalAttributes[0].forEach(function (attribute) {
      var attributeKey = attribute.attributeKey,
          attributeValue = attribute.attributeValue;

      if (!attributeMap[attributeKey]) {
        attributeMap[attributeKey] = 1;
        normalizedAttributes.push({
          attributeKey: attributeKey,
          attributeValue: attributeValue
        });
      }
    });
    return {
      combinationId: key,
      attributes: normalizedAttributes.concat(competitiveProducts.attributes)
    };
  });
  var modelMappingIds = competitors.map(function (_a) {
    var normalizationId = _a.normalizationId;
    return normalizationId;
  });
  return getCompetitorsPrices(combinations, modelMappingIds);
};

export var getEquivalency = function getEquivalency(dispatch, getState) {
  return __awaiter(void 0, void 0, void 0, function () {
    var skuData, _a, sellers, hasPermissionForFulfiller, _b, sku_1, selectorData, resolvedAttributes, sellerAccountId_1, hasEquivalencies, createConfigurationPromises_1, equivalencyMap_1, rowPivot_1, productConfigurations, productConfigurationUrls, equivalencyMapKeys, i, productEquivalencyPromises_1, equivalencyResults, equivalentSkus, prodcutConfigPromises, i, equivalenciesFound, j, _c, referenceId, productUrl, resultMappingHelper_1, mapIndex_1, equivalentProductConfigs, equivalentProductConfigMap_1, sellerIds_1, activeTermPromises, detailedContractInfo_1, sellerNameMap_1, sellerNamePromises, pricePromises_1, _d, priceResults, sellerNameResults, _e, headers, rowData_1, rowMap_1, i, columnValues_1, networkHeader_1, e_1;

    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          skuData = getState().pricingGrid.skuData;
          _a = getState().priceExplorerGrid, sellers = _a.sellers, hasPermissionForFulfiller = _a.hasPermissionForFulfiller;

          if (!skuData || Object.entries(skuData).length < 1) {
            return [2
            /*return*/
            ];
          }

          _f.label = 1;

        case 1:
          _f.trys.push([1, 8,, 9]);

          _b = __read(Object.entries(skuData)[0], 2), sku_1 = _b[0], selectorData = _b[1];
          resolvedAttributes = selectorData && selectorData.resolvedAttributes;
          sellerAccountId_1 = sellers[sku_1][selectorData.sellerId].accountId;

          if (!sellerAccountId_1 || !hasPermissionForFulfiller[sku_1]) {
            return [2
            /*return*/
            ];
          }

          return [4
          /*yield*/
          , request(util.format('https://equivalency.products.cimpress.io/v3/products/%s/equivalencies', sku_1)).then(function (response) {
            return response && response.equivalencies.length > 0;
          })];

        case 2:
          hasEquivalencies = _f.sent();

          if (!hasEquivalencies) {
            return [2
            /*return*/
            ];
          }

          dispatch(setIsLoadingEquivalencies(true));
          createConfigurationPromises_1 = [];
          equivalencyMap_1 = {}; // 1: Create product configurations for all fully resolved combinations

          resolvedAttributes.forEach(function (resolvedAttribute) {
            var _a;

            var key = resolvedAttribute.key,
                values = resolvedAttribute.values;

            if (!rowPivot_1) {
              _a = __read(key.split('|'), 1), rowPivot_1 = _a[0];
            }

            values.forEach(function (value) {
              var state = value.state,
                  attributes = value.attributes;
              var mapKey = key + "||" + (value.key || '');

              if (state === 'fullyResolved') {
                var attributeMap_2 = {};
                attributes.forEach(function (attribute) {
                  var attributeKey = attribute.attributeKey,
                      attributeValue = attribute.attributeValue;
                  attributeMap_2[attributeKey + "|" + attributeValue] = {
                    attributeKey: attributeKey,
                    attributeValue: attributeValue
                  };
                });
                createConfigurationPromises_1.push(createProductConfiguration(sku_1, Object.values(attributeMap_2), true));
                equivalencyMap_1[mapKey] = 1;
              }
            });
          });
          return [4
          /*yield*/
          , Promise.all(createConfigurationPromises_1)];

        case 3:
          productConfigurations = _f.sent();
          productConfigurationUrls = [];
          equivalencyMapKeys = Object.keys(equivalencyMap_1);

          for (i = 0; i < productConfigurations.length; i++) {
            if (productConfigurations[i] && productConfigurations[i].validationUri) {
              productConfigurationUrls.push(productConfigurations[i].validationUri);
            } else {
              equivalencyMap_1[equivalencyMapKeys[i]] = undefined;
            }
          }

          if (productConfigurationUrls.length < 1) {
            dispatch(setIsLoadingEquivalencies(false));
            return [2
            /*return*/
            ];
          }

          productEquivalencyPromises_1 = []; // 2: Get equivalent product configurations for all product configuration from step 1

          productConfigurationUrls.forEach(function (productConfiguration) {
            productEquivalencyPromises_1.push(request(util.format('https://equivalency.products.cimpress.io/v3/equivalencies?productUrl=%s', productConfiguration)));
          });
          return [4
          /*yield*/
          , Promise.all(productEquivalencyPromises_1)];

        case 4:
          equivalencyResults = _f.sent();
          equivalentSkus = [];
          equivalencyMapKeys = Object.keys(equivalencyMap_1);
          prodcutConfigPromises = [];

          for (i = 0; i < equivalencyResults.length; i++) {
            equivalenciesFound = 0;

            for (j = 0; j < equivalencyResults[i].length; j++) {
              _c = equivalencyResults[i][j], referenceId = _c.referenceId, productUrl = _c.productUrl;

              if (referenceId !== sku_1 && productUrl) {
                prodcutConfigPromises.push(request(productUrl));
                equivalenciesFound++;

                if (!equivalentSkus.includes(referenceId)) {
                  equivalentSkus.push(referenceId);
                }
              }
            }

            equivalencyMap_1[equivalencyMapKeys[i]] = equivalenciesFound;
          }

          resultMappingHelper_1 = {};
          mapIndex_1 = 0;
          Object.entries(equivalencyMap_1).forEach(function (entry) {
            var _a = __read(entry, 2),
                key = _a[0],
                value = _a[1];

            for (var i = 0; i < value; i++) {
              resultMappingHelper_1[mapIndex_1++] = key;
            }
          });

          if (prodcutConfigPromises.length < 1) {
            dispatch(setIsLoadingEquivalencies(false));
            return [2
            /*return*/
            ];
          }

          return [4
          /*yield*/
          , Promise.all(prodcutConfigPromises)];

        case 5:
          equivalentProductConfigs = _f.sent();
          equivalentProductConfigMap_1 = {};
          equivalentProductConfigs.forEach(function (equivalentProductConfig) {
            if (!equivalentProductConfigMap_1[equivalentProductConfig.mcpSku]) {
              equivalentProductConfigMap_1[equivalentProductConfig.mcpSku] = [];
            }

            equivalentProductConfigMap_1[equivalentProductConfig.mcpSku].push(equivalentProductConfig);
          });
          sellerIds_1 = [];
          activeTermPromises = equivalentSkus.map(function (item) {
            return request("https://pricingterm.financialflows.cimpress.io/api/v0/activeterms:searchbysku?sku=" + item);
          });
          detailedContractInfo_1 = {};
          return [4
          /*yield*/
          , Promise.all(activeTermPromises).then(function (responses) {
            responses.forEach(function (response) {
              var activeContractsInfo = response.activeTerms || null;

              if (activeContractsInfo && activeContractsInfo.length > 0) {
                // only consider contracts where accountId of seller of original sku and buyer of equivalent sku are same
                var matchingContracts = activeContractsInfo.filter(function (_a) {
                  var isEffective = _a.isEffective,
                      activeTerm = _a.activeTerm;
                  return isEffective && activeTerm.buyer.accountId === sellerAccountId_1;
                }).map(function (item) {
                  return item.activeTerm;
                });

                if (matchingContracts.length > 0) {
                  detailedContractInfo_1[activeContractsInfo[0].activeTerm.sku] = {};
                  matchingContracts.forEach(function (item) {
                    var id = item.seller.id;
                    detailedContractInfo_1[activeContractsInfo[0].activeTerm.sku][id] = item;
                  });
                }
              }
            });
          })];

        case 6:
          _f.sent();

          if (Object.entries(detailedContractInfo_1).length < 1) {
            dispatch(setIsLoadingEquivalencies(false));
            return [2
            /*return*/
            ];
          } // Create sellerIds array to store all unique sellers


          Object.values(detailedContractInfo_1).forEach(function (activeTermMap) {
            Object.values(activeTermMap).forEach(function (term) {
              var sid = term.seller.id;

              if (!sellerIds_1.includes(sid)) {
                sellerIds_1.push(sid);
              }
            });
          });
          sellerNameMap_1 = {};
          sellerNamePromises = sellerIds_1.map(function (item) {
            return request("https://fulfilleridentity.trdlnk.cimpress.io/v1/fulfillers/" + item + "?showFlags=false");
          });
          pricePromises_1 = [];
          Object.entries(equivalentProductConfigMap_1).forEach(function (entry) {
            var _a = __read(entry, 2),
                skuId = _a[0],
                configs = _a[1];

            var iterations = configs.map(function (config) {
              return {
                valueAttributes: config.attributes
              };
            });

            if (detailedContractInfo_1[skuId]) {
              Object.values(detailedContractInfo_1[skuId]).forEach(function (info) {
                var _a = info.buyer,
                    buyerId = _a.id,
                    buyerType = _a.type,
                    _b = info.seller,
                    sellerId = _b.id,
                    sellerType = _b.type;
                pricePromises_1.push(getContractPrices(true, skuId, {
                  sellerId: sellerId,
                  sellerType: sellerType
                }, [{
                  buyerId: buyerId,
                  buyerType: buyerType
                }], {
                  iterations: iterations
                }));
              });
            }
          });
          return [4
          /*yield*/
          , Promise.all([Promise.all(pricePromises_1), Promise.all(sellerNamePromises)])];

        case 7:
          _d = __read.apply(void 0, [_f.sent(), 2]), priceResults = _d[0], sellerNameResults = _d[1];
          sellerNameResults.forEach(function (result) {
            sellerNameMap_1[result.fulfillerId] = result.name;
          });
          _e = getState().priceExplorerGrid, headers = _e.headers, rowData_1 = _e.rowData;

          if (!rowData_1 || !rowData_1.length) {
            dispatch(setIsLoadingEquivalencies(false));
            return [2
            /*return*/
            ];
          }

          rowMap_1 = {};

          for (i = 0; i < rowData_1.length; i++) {
            rowMap_1[rowData_1[i][rowPivot_1]] = i;
          }

          columnValues_1 = [];
          Object.entries(resultMappingHelper_1).forEach(function (entry) {
            var _a = __read(entry, 2),
                key = _a[0],
                value = _a[1];

            var _b = __read(value.split('||'), 2),
                row = _b[0],
                column = _b[1];

            var columnValue = column.length ? column.split('|')[1] : undefined;

            if (columnValue && !columnValues_1.includes(columnValue)) {
              columnValues_1.push(columnValue);
            }

            resultMappingHelper_1[key] = {
              rowIndex: rowMap_1[row.split('|')[1]],
              columnValue: columnValue
            };
          });
          networkHeader_1 = find(headers.headerList, {
            name: 'Network'
          });

          if (!networkHeader_1) {
            networkHeader_1 = {
              name: 'Network',
              value: sku_1 + "|Network",
              children: [],
              isParent: true
            };
            headers.headerList.push(networkHeader_1);
          } // Add results to rowData and header


          priceResults.forEach(function (priceResult) {
            var _a = priceResult[0],
                sellerCode = _a.seller.sellerId,
                evaluationGroups = _a.evaluationGroups,
                mcpSku = _a.mcpSku;
            var headerValue = sku_1 + "|Equivalencies|" + sellerNameMap_1[sellerCode] + "|";
            var _b = detailedContractInfo_1[mcpSku][sellerCode],
                _c = _b.priceModel,
                priceModelId = _c.id,
                revisionId = _c.revisionId,
                contractId = _b.termId,
                contractRevisionId = _b.revisionId,
                effectiveStartDate = _b.effectiveStartDate;
            var columnHeader = {
              name: mcpSku + " - " + sellerNameMap_1[sellerCode],
              value: headerValue + "|",
              isParent: false,
              info: {
                priceModelId: priceModelId,
                revisionId: revisionId,
                contractId: contractId,
                contractRevisionId: contractRevisionId,
                effectiveStartDate: effectiveStartDate,
                equivalentSku: mcpSku
              },
              children: []
            };

            if (columnValues_1.length) {
              columnHeader.isParent = true;
              columnHeader.children = [];
              columnHeader.value = headerValue;
              columnValues_1.forEach(function (name) {
                columnHeader.children.push({
                  name: name,
                  value: "" + columnHeader.value + name + "|"
                });
              });
            }

            networkHeader_1.children.push(columnHeader);

            for (var i = 0; i < evaluationGroups.length; i++) {
              var _d = evaluationGroups[i],
                  attributes = _d.inputs,
                  error = _d.error,
                  price = _d.price;
              var quantity = null;
              var rowIndex = resultMappingHelper_1[i].rowIndex;
              var columnValue = resultMappingHelper_1[i].columnValue || '';
              var column = "" + headerValue + columnValue + "|";
              var quantityObject = attributes.find(function (attribute) {
                return attribute.attributeKey.toLowerCase() === 'quantity' && attribute.class.toLowerCase() === 'order';
              });

              if (quantityObject) {
                quantity = quantityObject.attributeValue;
              }

              rowData_1[rowIndex][column] = {
                attributes: attributes,
                errorMessage: error && error.code + ": " + error.message,
                productPrice: price && {
                  totalPrice: price.totalAmount,
                  displayPrice: price.totalAmount,
                  currency: price.currency
                },
                quantity: quantity
              };
            }
          });
          dispatch(setRowDataByResults(null));
          dispatch(setGridHeaders(null));
          dispatch(setRowDataByResults(rowData_1));
          dispatch(setGridHeaders(headers));
          dispatch(setIsLoadingEquivalencies(false));
          return [3
          /*break*/
          , 9];

        case 8:
          e_1 = _f.sent();
          dispatch(setIsLoadingEquivalencies(false));
          return [3
          /*break*/
          , 9];

        case 9:
          return [2
          /*return*/
          ];
      }
    });
  });
}; // Redux thunk function to calculate price for grid

export var calculate = function calculate(isSingleSkuEnvironment) {
  return function (dispatch, getState) {
    var skuData = getState().pricingGrid.skuData;
    var _a = getState().pricingGrid,
        showCompetitivePricing = _a.showCompetitivePricing,
        competitors = _a.competitors,
        productPriceContractsInfo = _a.productPriceContractsInfo;
    var _b = getState().priceExplorerGrid,
        sellers = _b.sellers,
        rowData = _b.rowData,
        headers = _b.headers,
        pricingVersion = _b.pricingVersion,
        priceConfigurations = _b.priceConfigurations;

    if (!Object.keys(sellers).length && !(priceConfigurations && priceConfigurations.length)) {
      return null;
    }

    dispatch(setCancelablePromise()); // if cancelable promise already exists, nullify it

    if (rowData || headers) {
      dispatch(setRowDataByResults()); // set row Data to null
    }

    if (isSingleSkuEnvironment) {
      var stateMap = Object.values(skuData).map(function (_a) {
        var state = _a.state;
        return state;
      });

      if (stateMap.find(function (state) {
        return state === CONSTANTS.ERROR;
      })) {
        dispatch(setRowDataByResults([]));
        dispatch(setGridHeaders([]));
        return null;
      }

      if (stateMap.find(function (state) {
        return state !== CONSTANTS.FULLYRESOLVED;
      })) {
        if (showCompetitivePricing) {
          dispatch(createCompetitiveHeaders(skuData, competitors, showCompetitivePricing));
        } else {
          dispatch(createHeaders(skuData, isSingleSkuEnvironment, showCompetitivePricing, productPriceContractsInfo));
        }

        return createDummyResults({
          error: undefined,
          sku: Object.keys(skuData)[0],
          dispatch: dispatch,
          getState: getState
        });
      }
    }

    if (showCompetitivePricing) {
      dispatch(createCompetitiveHeaders(skuData, competitors, showCompetitivePricing));
    } else {
      if (pricingVersion === 'v1') {
        getEquivalency(dispatch, getState);
      }

      dispatch(createHeaders(skuData, isSingleSkuEnvironment, showCompetitivePricing, productPriceContractsInfo));
    }

    var promises = Object.keys(skuData).map(function (sku) {
      if (sku === 'competitorProducts') {
        return getAllCompetitivePrices(skuData, competitors).then(function (result) {
          return {
            competitorProductsPrices: result
          };
        });
      }

      return calculatePriceList(isSingleSkuEnvironment, sku, dispatch, getState);
    });
    var shippingPromises = Object.keys(skuData).map(function (sku) {
      if (sku === 'competitorProducts' || productPriceContractsInfo) {
        return null;
      }

      return fetchShippingValues(sku, dispatch, getState);
    });
    var cancelablePricingPromise = makeCancelable(Promise.all([Promise.all(promises), Promise.all(shippingPromises)]));
    dispatch(setCancelablePromise(cancelablePricingPromise));
    return cancelablePricingPromise.promise.then(function (results) {
      var _a, _b;

      var _c = __read(results, 2),
          pricingResults = _c[0],
          shippingResults = _c[1];

      if (pricingVersion === 'v1') {
        var attributeValues_1 = [];
        var rows_1 = {};
        var finalRowData_1 = [];
        var attributeKey_1 = capitalize(get(Object.values(skuData)[0], 'selectedRow.key'));
        pricingResults.filter(function (result) {
          return !result.competitorProductsPrices;
        }).forEach(function (result) {
          attributeValues_1 = attributeValues_1.concat(Object.keys(result).map(function (key) {
            return key.split('|')[1];
          }));
          Object.keys(result).forEach(function (rs) {
            if (!rows_1[rs]) {
              rows_1[rs] = [];
            }

            rows_1[rs] = rows_1[rs].concat(result[rs]);
          });
        });
        attributeValues_1 = __spread(new Set(attributeValues_1));
        sort(attributeValues_1);
        attributeValues_1.forEach(function (attributeValue) {
          var rowKey = attributeKey_1 + "|" + attributeValue;
          var tempRowData = {};
          tempRowData[attributeKey_1] = attributeValue;

          if (rows_1[rowKey]) {
            rows_1[rowKey].forEach(function (rowValue) {
              tempRowData = __assign(__assign({}, tempRowData), rowValue);
            });
          }

          finalRowData_1.push(tempRowData);
        });

        if (showCompetitivePricing && pricingResults && ((_a = pricingResults[1]) === null || _a === void 0 ? void 0 : _a.competitorProductsPrices)) {
          var combinations_1 = ((_b = pricingResults[1]) === null || _b === void 0 ? void 0 : _b.competitorProductsPrices).combinations;
          finalRowData_1 = finalRowData_1.map(function (row, index) {
            var quantity = row.Quantity;
            var _a = combinations_1[index],
                combinationId = _a.combinationId,
                price = _a.price,
                attributes = _a.attributes;
            var competitiveQuantity = combinationId.split('|')[1];

            if (quantity === competitiveQuantity) {
              var competitorsPrices_1 = {};
              competitors.forEach(function (_a) {
                var normalizationId = _a.normalizationId,
                    competitorName = _a.competitorName;
                var competitorPriceKey = Object.keys(price).find(function (competitorId) {
                  return competitorId === normalizationId.toString();
                });
                var productPrice = null;

                if (competitorPriceKey) {
                  var _b = price[competitorPriceKey],
                      amount = _b.amount,
                      currency = _b.currency;

                  if (amount) {
                    productPrice = {
                      totalPrice: amount,
                      displayPrice: amount,
                      currency: currency
                    };
                  }
                }

                competitorsPrices_1[normalizationId + "|" + competitorName] = {
                  attributes: attributes,
                  productPrice: productPrice,
                  quantity: quantity
                };
              });
              return __assign(__assign({}, row), competitorsPrices_1);
            }

            return row;
          });
        }

        if (shippingResults && shippingResults[0]) {
          dispatch(copyShippingResults(shippingResults[0].sku, skuData, shippingResults[0].result, finalRowData_1));
        }

        dispatch(setRowDataByResults(finalRowData_1));
        return results;
      }

      dispatch(setRowDataByResults(pricingResults[0]));
      return results;
    });
  };
};
export var fetchShippingValues = function fetchShippingValues(sku, dispatch, getState) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a, skuData, shippingConfiguration, priceMode, _b, sellers, contractsPerSku, catalogPriceModelsPerSku, manufacturingCostModelsPerSku, savedShippingConfig, skuProductionTimes, packs, quantities, productionTimeResults, skuProductionTimeKeys, promises, results, rowCount, i, shippingInputs, shippingPriceCatalogPromise, contracts, shippingPriceFromPricer;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = getState().pricingGrid, skuData = _a.skuData, shippingConfiguration = _a.shippingConfiguration, priceMode = _a.priceMode;
          _b = getState().priceExplorerGrid, sellers = _b.sellers, contractsPerSku = _b.contractsPerSku, catalogPriceModelsPerSku = _b.catalogPriceModelsPerSku, manufacturingCostModelsPerSku = _b.manufacturingCostModelsPerSku;
          savedShippingConfig = cloneDeep(shippingConfiguration);

          if (!savedShippingConfig || !sellers[sku] || Object.keys(savedShippingConfig).length === 0 || !savedShippingConfig.fulfillmentLocation) {
            return [2
            /*return*/
            , {
              sku: sku,
              result: {
                catalogPrice: null,
                shippingContracts: null
              }
            }];
          }

          skuProductionTimes = {};
          packs = {};
          quantities = {}; // eslint-disable-next-line no-console

          if (!skuData[sku].resolvedAttributes) {
            return [2
            /*return*/
            , {
              sku: sku,
              result: {
                catalogPrice: null,
                shippingContracts: null,
                shippingManufacturing: null
              }
            }];
          }

          skuData[sku].resolvedAttributes.forEach(function (resolvedAttribute, index) {
            var key = resolvedAttribute.key;
            var shippingKey = key + "||";
            var totalValues = resolvedAttribute.values.length;

            if (totalValues === 0) {
              skuProductionTimes[shippingKey] = null;
              packs[shippingKey] = null;
              quantities[shippingKey] = null;
            } else if (totalValues === 1) {
              var attributes = resolvedAttribute.values[0].attributes;
              skuProductionTimes[shippingKey] = getProductionTimeForSku(sku, attributes);
              packs[shippingKey] = fetchPackDefinitions(attributes);
              quantities[shippingKey] = fetchQuantityFromData(attributes);
            } else {
              resolvedAttribute.values.forEach(function (value) {
                var dualPivotKey = value.key; // eslint-disable-next-line prefer-destructuring

                dualPivotKey = dualPivotKey.split('|')[1];
                dualPivotKey = shippingKey + dualPivotKey;

                if (!value.attributes) {
                  skuProductionTimes[dualPivotKey] = null;
                  packs[dualPivotKey] = null;
                  quantities[dualPivotKey] = null;
                } else {
                  var attributes = value.attributes;
                  skuProductionTimes[dualPivotKey] = getProductionTimeForSku(sku, attributes);
                  packs[dualPivotKey] = fetchPackDefinitions(attributes);
                  quantities[dualPivotKey] = fetchQuantityFromData(attributes);
                }
              });
            }
          });
          productionTimeResults = {};
          skuProductionTimeKeys = Object.keys(skuProductionTimes);
          promises = Object.values(skuProductionTimes);
          return [4
          /*yield*/
          , Promise.all(promises)];

        case 1:
          results = _c.sent();
          rowCount = skuProductionTimeKeys.length;

          for (i = 0; i < rowCount; i++) {
            productionTimeResults[skuProductionTimeKeys[i]] = results[i];
          }

          shippingInputs = {
            productionTimeResults: productionTimeResults,
            packs: packs,
            quantities: quantities,
            rowCount: rowCount
          };
          shippingPriceCatalogPromise = getShippingPrices(sku, sellers[sku], catalogPriceModelsPerSku, shippingConfiguration, shippingInputs, priceMode); // If no fulfillment location is selected, only return catalog price

          if (!shippingConfiguration.fulfillmentLocation) {
            return [2
            /*return*/
            , Promise.all([shippingPriceCatalogPromise]).then(function (result) {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2
                  /*return*/
                  , {
                    sku: sku,
                    result: {
                      catalogPrice: result[0],
                      shippingContracts: null,
                      shippingManufacturing: null
                    }
                  }];
                });
              });
            })];
          }

          contracts = contractsPerSku[sku];
          shippingPriceFromPricer = getShippingPricesForContracts(sku, sellers[sku], manufacturingCostModelsPerSku[sku], contracts, shippingConfiguration, skuData[sku].resolvedAttributes, priceMode, getState);
          return [2
          /*return*/
          , Promise.all([shippingPriceCatalogPromise, shippingPriceFromPricer]).then(function (shippingResults) {
            var _a = __read(shippingResults, 2),
                shippingCatalog = _a[0],
                shippingDataPricer = _a[1];

            var shippingContracts = shippingDataPricer.contractsShippingResults,
                shippingManufacturing = shippingDataPricer.manufacturingCostShippingResults;
            var result = {
              shippingCatalog: shippingCatalog,
              shippingContracts: shippingContracts,
              shippingManufacturing: shippingManufacturing
            };
            return {
              sku: sku,
              result: result
            };
          })];
      }
    });
  });
};
export var getShippingResults = function getShippingResults(rowData) {
  return function (dispatch, getState) {
    var skuData = getState().pricingGrid.skuData;

    try {
      var currentRowData_1 = cloneDeep(rowData);
      var shippingPromises = Object.keys(skuData).map(function (sku) {
        return fetchShippingValues(sku, dispatch, getState);
      });
      var cancelableShippingPromise = makeCancelable(Promise.all(shippingPromises));
      dispatch(setCancelablePromise(cancelableShippingPromise));
      return cancelableShippingPromise.promise.then(function (results) {
        results.forEach(function (shippingResult) {
          if (shippingResult) {
            var sku = shippingResult.sku,
                result = shippingResult.result;
            dispatch(copyShippingResults(sku, skuData, result, currentRowData_1));
          }
        });
      });
    } catch (e) {
      // If error in calculating shipping, set row data (As rowData is set to null before function call, to evoke loading spinner)
      return dispatch(setRowDataByResults(rowData));
    }
  };
};
export var copyShippingResults = function copyShippingResults(sku, skuData, shippingResult, finalRowData) {
  return {
    type: actionTypes.ADD_SHIPPING_DATA_TO_ROW_DATA,
    payload: {
      sku: sku,
      skuData: skuData,
      shippingResult: shippingResult,
      finalRowData: finalRowData
    }
  };
};
export var saveLoggedSku = function saveLoggedSku(sku) {
  return {
    type: actionTypes.SAVE_LOGGED_SKU,
    payload: sku
  };
};
export var saveUserPermissionForFulfiller = function saveUserPermissionForFulfiller(hasPermissionForFulfiller) {
  return {
    type: actionTypes.SAVE_USER_PERMISSION_FULFILLER,
    payload: hasPermissionForFulfiller
  };
};